import React, { Component } from 'react';
import { observer, inject} from 'mobx-react';
import { Redirect } from 'react-router-dom';
import ForgotPasswordForm from './forgotPasswordForm';
import ForgotPasswordEmailSent from './forgotPasswordEmailSent';
import SharedLoginForm from '../sharedLoginForm';

@inject('usersStore', 'firstAdminRegisterationStore', 'configurationsStore') @observer
class ForgotPassword extends Component {

    state = {
        emailSent: false
    };

    handleResetPasswordClick = (e) => {       
        this.setState({
            emailSent: true
        });
    }
    componentDidMount(){
        this.props.configurationsStore.updateStore();
    }

    componentWillMount() {
        this.props.firstAdminRegisterationStore.firstAdminExistence();
    }

    render(){
        
        if(this.props.usersStore.currentUser != undefined){
            return <Redirect to='/' />;
        }

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence == null) {
            return null;
        }

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence.firstAdminExists === false) {          
            return <Redirect to='/' />;
        }

        let formComponent = <ForgotPasswordForm handleResetPassword={ this.handleResetPasswordClick }/>;

        if (this.state.emailSent === true) {           
            formComponent = <ForgotPasswordEmailSent />;
        }

        return(           
            <div data-cy='forgot-password-screen'>
                <SharedLoginForm component={formComponent} hideLoginLinks={this.state.emailSent} />
            </div>
        );
    }
}

export default ForgotPassword;


// WEBPACK FOOTER //
// ./src/components/account/forgotPasswordFlow/forgotPassword.jsx